import React, { useRef, useEffect, useCallback, ChangeEvent } from 'react';
import { useField } from '@unform/core';

import { Container } from './styles';

interface FileInputProps {
  name: string;
  label?: string;
}

const FileInput: React.FC<FileInputProps> = ({ name, label }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  const handleFileChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    if (inputRef.current?.files) {
      inputRef.current.dataset.file = e.target.files![0] ? e.target.files![0].name : '';
    }
  }, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'files[0]',
      clearValue(ref: HTMLInputElement) {
        ref.value = '';
        ref.dataset.file = '';
      },
      setValue(ref: HTMLInputElement, value: File) {
        if (value) {
          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(value);
          ref.files = dataTransfer.files;
          ref.dataset.file = value.name;
        } else {
          ref.value = '';
          ref.dataset.file = '';
        }
      },
    });
  }, [fieldName, registerField]);

  return (
    <Container isErrored={!!error}>
      {label && <label htmlFor={fieldName}>{label}</label>}
      <input
        type="file"
        ref={inputRef}
        id={fieldName}
        onChange={handleFileChange}
        accept=".pdf" // <--- Adicione esta linha
      />
      {error && <span>{error}</span>}
    </Container>
  );
};

export default FileInput;
